import { b as F } from "./withEditable-7d0a220a.js";
import { jsxs as N, jsx as O } from "react/jsx-runtime";
import { AuthoringUtils as _ } from "@adobe/aem-spa-page-model-manager";
import { ComponentAnalyticsDefinitions as k } from "@ucl/react-library/analytics";
import { Button as A } from "@ucl/react-library/button";
import { useFCAnalytics as L } from "@ucl/react-library/hooks_internal";
import w, { useMemo as C, useState as V, useCallback as g } from "react";
import { m as v } from "./EditableComponentUtils-0b5699b7.js";
import "html-react-parser";
import "sanitize-html";
import { s as W } from "./sanitizeProps-304c699d.js";
import "@adobe/aem-react-editable-components";
import "./PageContext-57b2437f.js";
import "./component-a7888ba1.js";
import "@ucl/react-library/useIsMounted";
import "./ComponentContext-3bb2d205.js";
import "./withErrorBoundary.js";
import "@ucl/shared-component-foundations/foundations";
import "styled-components";
import "./index-0371017d.js";
const Y = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "tertiary",
  solid: "primary",
  outline: "secondary"
  // Deprecated: needed until the AEM repo can remove this prop (end of Q2)
}, $ = {
  default: "default",
  danger: "danger",
  black: "black",
  success: "success",
  caution: "caution",
  onColor: "onColor",
  primary: "default",
  destructive: "danger"
  // Deprecated: needed until the AEM repo can remove this prop (end of Q2)
}, q = /* @__PURE__ */ w.lazy(() => import("./ModalWindow-329cec61.js").then((t) => t.b)), D = ({ buttonText: t, underlineLink: o, buttonAs: T = "button", as: p = T, ariaLabel: U, variant: a, color: u, onClick: n, platformAnalyticsData: i, runtimeAnalyticsData: j, openModal: s, openModalOnPageLoad: c, modalTriggerQueryParams: r, modalWindow: l, icon: f, iconPosition: h = "left", renderModal: m, ...x }) => {
  const b = C(() => _.isInEditor(), []), I = C(() => {
    if (b)
      return !1;
    if (r && Object.keys(r).length > 0) {
      const e = new URLSearchParams(window.location.search);
      return Object.entries(r).every(([S, z]) => e.get(S) === z) && c;
    }
    return c;
  }, [
    c,
    b,
    r
  ]), [y, d] = V(I), E = L(i, j), R = g((e) => {
    if (i && E(k.BUTTON), s) {
      e.preventDefault(), d(!0);
      return;
    }
    n == null || n(e);
  }, [
    s,
    E,
    n,
    i
  ]), B = g(() => d(!1), []);
  return /* @__PURE__ */ N(w.Fragment, {
    children: [
      /* @__PURE__ */ O(A, {
        as: p === "anchor" ? "a" : p,
        underlined: o,
        leftIcon: h === "left" ? f : void 0,
        rightIcon: h === "right" ? f : void 0,
        "aria-label": U,
        variant: Y[a] || a,
        color: $[u] || u,
        onClick: R,
        ...W(x),
        children: t
      }),
      s && ((m == null ? void 0 : m({
        ...v(l),
        isOpen: y,
        onClose: B
      })) || /* @__PURE__ */ O(q, {
        ...v(l),
        isOpen: y,
        onClose: B
      }))
    ]
  });
}, G = (t) => {
  var o;
  return !((o = t.buttonText) != null && o.trim().length);
}, H = "ucl/components/button", J = {
  emptyLabel: "Button",
  isEmpty: G,
  resourceType: H
}, bt = F(J, D);
export {
  H as BUTTON_RESOURCE_TYPE,
  bt as EditableButton
};
